import { DateTime } from 'luxon';

import { ImportStatusEnum } from 'api';

export const POLLING_INTERVAL_MS = 5 * 1000; //5 seconds
export const BULK_ACTION_TIMEOUT_MS = 60 * 60 * 1000; // 1 hour

export interface UploadError {
  status?: number;
  data?: { errors?: Array<{ message: string }>; error?: Array<{ message: string }> };
}

export const getUploadErrorMessages = (error: unknown): string[] => {
  const data =
    error && typeof error === 'object' && 'data' in error
      ? (error.data as UploadError['data'])
      : undefined;
  return (
    data?.errors?.map((e) => e.message) ??
    data?.error?.map((e) => e.message) ?? ['An unexpected error occurred.']
  );
};

export const getPollingState = (
  currentImport: { status: ImportStatusEnum; scheduledTimestamp?: string | null } | null | undefined
) => {
  const isPending = currentImport?.status === ImportStatusEnum.Pending;
  const isTimedOut =
    isPending &&
    !!currentImport?.scheduledTimestamp &&
    DateTime.utc().diff(DateTime.fromISO(currentImport.scheduledTimestamp)).as('milliseconds') >=
      BULK_ACTION_TIMEOUT_MS;
  const shouldPoll = isPending && !isTimedOut;
  return { shouldPoll, isTimedOut, nextPollingMs: shouldPoll ? POLLING_INTERVAL_MS : 0 };
};
